import React, { useEffect, useRef } from "react";
//Material ui
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
//Icons
import InfoDuda from "../../assets/icons/InfoDuda.svg";
import arrowUp from "../../assets/icons/Up.svg";
import arrowDown from "../../assets/icons/down.svg";
import IconPdfBlanco from "../../assets/icons/IconPdfBlanco.svg"; //PDF Blanco
import IconPdf from "../../assets/icons/IconPdf.svg"; //PDF Azul
import IconId from "../../assets/icons/idIcon.svg";
import IconReparto from "../../assets/icons/camionRepartoIcon.svg";
import entregaIcon from "../../assets/icons/entregaIcon.svg";
import IconFecha from "../../assets/icons/fecha.svg";
import IconLista from "../../assets/icons/iconLista.svg";

import { useState } from "react";
import * as Constant from "../../global/const";
//axios
import axios from "axios";
import Loader from "react-loader-spinner";
import CabezoteComponent from "../Cabezote/cabezote.component";
import Footer from "../Footer/Footer.components";
import { useReactToPrint } from "react-to-print";
import Print from "./Print";
import { useDispatch } from "react-redux";
import { setCarrito } from "../../Redux/actions/CarritoAction";
import { setCarritoPromos } from "../../Redux/actions/CarritoPromoAction";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const ThankYou = (props) => {
  const componentRef = useRef();
  // const classes = useStyles();

  const [mostrarOpciones, setMostrarOpciones] = useState(false);

  const [expanded, setExpanded] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [close, setclose] = useState(true);
  const [orden, setorden] = useState([]);
  const [obsequios, setObsequios] = useState([]); //obsequios
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    documentTitle: `Pedido - Postobonb2b`,
  });
  const dispatch = useDispatch();
  const dispatchPromo = useDispatch();
  const AgregarCarrito = (carrito) => dispatch(setCarrito(carrito));
  const AgregarCarritoPromos = (carritoPromos) =>
    dispatchPromo(setCarritoPromos(carritoPromos));

    
  const [listaNumOrden, setListaNumOrden] = useState([]);
  const getObsequios = async (orden) => {
    let auxObsequios = [];

    await Promise.all(
      orden.listaEncabezado.map((encabezado)=>{
        encabezado.promociones.map((producto, i) => {
          producto.detallePromocion.map((promocion, j) => {
            auxObsequios.push(promocion);
          });
        })
      })
    );

    setObsequios(auxObsequios);
  };

  const getRecibo = (orden) => {
    axios
      .get(Constant.GETRECIBOPEDIDOS + "?numPadre=" + orden)
      .then((response) => {
        setorden(response.data);
        setListaNumOrden(response.data.pedido.listaNumOrden)
        //getObsequios(response.data);
        localStorage.removeItem(Constant.CARRITO);
        localStorage.removeItem(Constant.CARRITOPROMO);
        AgregarCarrito({});
        AgregarCarritoPromos({});
      })
      .catch((err) => {
        console.log("error ", err);
      });
  };

  const handleChange = (panel) => {
    setExpanded(panel === expanded ? false : panel);
  };

  useEffect(() => {
    if (props.match.params.orden) getRecibo(props.match.params.orden);
  }, []);
  return (
    <div className="home">
      <CabezoteComponent
        open={open}
        setOpen={setOpen}
        tipo={false}
        categoriasGlobal={null}
        close={close}
        setclose={setclose}
        mostrarOpciones={mostrarOpciones}
        setMostrarOpciones={setMostrarOpciones}
      />
      {orden.length !== 0 ? (
        <div className="contentThank">
          <div className="HeaderThank">
            <h1>¡Gracias! Tu pedido ya está programado</h1>
            <span>{orden.mensaje}</span>
          </div>
          <div className="BodyThank">
            <div className="HeadResumen">
              <h1>Resumen del pedido</h1>
              <div className="btn_pdf no-seleccionable" onClick={handlePrint}>
                {/**insertar imagen PDF pero blanco */}
                <img src={IconPdfBlanco} alt="" />
                <span>Descargar PDF</span>
              </div>
              <img src={IconPdf} className="img_pdf" alt="" />
            </div>
            <div className="BodyResumen">
              <div className="panel">
                <div
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className="panelBody"
                >
                  <img src={IconId} alt="" />
                  <div className="listaOrdenes">
                    <h1 className="texto">
                      {"Orden(es) asociada(s) al pedido: "}
                    </h1>
                    <div className="listaNumOrden">
                    {
                        Object.keys(listaNumOrden).map((key) =>(
                          <span className="textoSpan">
                            {listaNumOrden[key]}
                          </span>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
              {/* lista de productos */}
              <Accordion expanded={expanded === "panel2"} className="panel">
                <AccordionSummary
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className="panelBody"
                >
                  <div className="panel_inside">
                    <div>
                      <img src={IconLista} alt="" />
                      <h1 className="texto">
                        Tu pedido tiene{" "}
                        <span className="textoSpan">
                          {orden.pedido.totalCantidadProductos +
                            orden.pedido.totalCantidadObsequios}{" "}
                          producto(s)
                        </span>{" "}
                        para un total de{" "}
                        <span className="textoSpan">
                          {" $" +
                            new Intl.NumberFormat("de-DE", {
                              numberingSystem: "latn",
                              style: "decimal",
                              currency: "COP",
                            }).format(orden.pedido.precio)}
                        </span>
                      </h1>
                    </div>
                    <div
                      className="btn_Open"
                      onClick={() => handleChange("panel2")}
                    >
                      <span>
                        <span>Ver</span> productos
                      </span>
                      <img
                        src={expanded === "panel2" ? arrowUp : arrowDown}
                        alt=""
                      />
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="list_products">
                    {
                      orden.listaEncabezado.map((encabezado) => 
                        (
                          <>
                          <span id="numOrden">{encabezado.numeroDoc}</span>
                            <div className="table_thankyou"> 
                              <span>Producto</span>
                              <span id="center_span">Cajas</span>
                              <span id="center_span">Unidades</span>
                              <span id="center_span">Total</span>
                            </div>
                          {
                          Object.keys(encabezado.productos).map((key,i) => {
                            let producto = encabezado.productos[key];
                            return(
                            <div className="product_row" key={i}>
                              <span>{producto.producto}</span>
                              <span id="center_span">{producto.cantidad}</span>
                              <span id="center_span">{producto.cantidadUnidadDigitada}</span>
                              <span id="center_span">
                                {" $" +
                                  new Intl.NumberFormat("de-DE", {
                                    numberingSystem: "latn",
                                    style: "decimal",
                                    currency: "COP",
                                  }).format(producto.total)}
                              </span>
                            </div>
                            )
                          })
                        }
                        {
                          Object.keys(encabezado.promociones).map((key,i) => {
                            let listaObsequio = encabezado.promociones[key];
                            return(
                            Object.keys(listaObsequio.detallePromocion).map((key, j) => {
                              const obsequio = listaObsequio.detallePromocion[key];
                              return(
                              <div className="product_row" >
                                <span>{obsequio.producto}</span>
                                <span id="center_span">{obsequio.cantidad}</span>
                                <span id="center_span">{obsequio.cantidadUnidadDigitada}</span>
                                <span id="center_span">
                                  {" $" +
                                    new Intl.NumberFormat("de-DE", {
                                      numberingSystem: "latn",
                                      style: "decimal",
                                      currency: "COP",
                                    }).format(obsequio.total)}
                                </span>
                              </div>
                              )
                            })
                            )
                            
                          })
                        }
                        </>
                      )
                    )}
                  </div>
                </AccordionDetails>
              </Accordion>
              {/* <div className="panel">
                  <div
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className="panelBody"
                  >
                    <img src={IconId} alt="" />
                    <h1 className="texto">
                      Descuento:
                      <span className="textoSpan"> {orden.pedido.valorDesc}</span>
                    </h1>
                  </div>
                </div> */}

              <Accordion expanded={expanded === "panel4"} className="panel">
                <AccordionSummary
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className="panelBody"
                >
                  <div className="panel_inside">
                    <div>
                      <img src={IconReparto} alt="" loading="lazy"/>
                      <h1 className="texto">
                        Se entregará en:{" "}
                        <span className="textoSpan">
                          {orden.pedido.direccion}{" "}
                        </span>
                      </h1>
                    </div>
                    <div
                      className="btn_Open"
                      onClick={() => handleChange("panel4")}
                    >
                      <span>
                        <span>Ver</span> detalle
                      </span>
                      <img
                        loading="lazy"
                        src={expanded === "panel4" ? arrowUp : arrowDown}
                        alt=""
                      />
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="detail">
                    <span>
                      Esta dirección pertenece a: {orden.pedido.direccion} -{" "}
                      {orden.pedido.ciudad}
                    </span>
                  </div>
                </AccordionDetails>
              </Accordion>

              {
                orden.pedido.valorDesc > 0 && (
                  <div
                className="panel"
              >
                <div
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className="panelBody"
                >
                  <img src={IconId} alt="" />
                  <h1 className="texto">
                    Descuento:{" "}
                    <span className="textoSpan">
                      {" $" +
                        new Intl.NumberFormat("de-DE", {
                        numberingSystem: "latn",
                        style: "decimal",
                        currency: "COP",
                        }).format(orden.pedido.valorDesc)} 
                    </span>
                  </h1>
                </div>
              </div>
                )
              }
              
              <div
                /*  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")} */
                className="panel"
              >
                <div
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className="panelBody"
                >
                  <img src={IconFecha} alt="" />
                  <h1 className="texto">
                    Para entrega el día:{" "}
                    <span className="textoSpan">
                      {orden.pedido.fechaEntrega.replace("T", " ").slice(0, 10)}
                    </span>
                  </h1>
                </div>
              </div>
              {orden.pedido.tipoPago && (
                <div
                  /*  expanded={expanded === "panel5"}
                  onChange={handleChange("panel5")} */
                  className="panel"
                >
                  <div
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className="panelBody"
                  >
                    <img src={entregaIcon} alt="" />
                    <h1 className="texto">
                      Método de pago:{" "}
                      <span className="textoSpan">{orden.pedido.tipoPago}</span>
                    </h1>
                  </div>
                </div>
              )}
              {orden.pedido.tipoPagoPorOrden &&
                orden.pedido.tipoPagoPorOrden.length > 0 && (
                  <Accordion
                    expanded={expanded === "panel6"}
                    className="panel"
                  >
                    <AccordionSummary
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                      className="panelBody"
                    >
                      <div className="panel_inside">
                        <div>
                          <img src={entregaIcon} alt="" loading="lazy" />
                          <h1 className="texto">Metodo de pago</h1>
                        </div>
                        <div
                          className="btn_Open"
                          onClick={() => handleChange("panel6")}
                        >
                          <span>
                            <span>Ver</span> detalle
                          </span>
                          <img
                            loading="lazy"
                            src={expanded === "panel6" ? arrowUp : arrowDown}
                            alt=""
                          />
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="tablaTipoPago">
                        {orden.pedido.tipoPagoPorOrden.map((item, i) => (
                          <div className="tablaTipoPago-orden" key={i}>
                            <span className="numOrden">{item.numOrden}</span>
                            <div className="tablaTipoPago-head">
                              <span>Sector</span>
                              <span>Tipo de pago</span>
                            </div>
                            <div className="tablaTipoPago-row">
                              <span>{item.tipoCompania}</span>
                              <span className="textoSpan">{item.tipoPago}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                )}
            </div>
          </div>
          <div className="FooterThank">
            <div
              className="btn_1 no-seleccionable"
              onClick={() => {
                props.history.push({
                  pathname: "/MiPerfil/MisPedidos",
                });
              }}
            >
              <span>Historial de pedidos</span>
            </div>
            <div
              className="btn_2 no-seleccionable"
              onClick={() => {
                props.history.push({
                  pathname: "/Catalogo/Categoria/-1/Todos/1",
                });
              }}
            >
              <span>Regresar al catálogo</span>
            </div>
            <div
              className="btn_2 no-seleccionable"
              onClick={() => {
                props.history.push({
                  pathname: "/MiPerfil/MisDatos",
                });
              }}
            >
              <span>Ir a mi cuenta</span>
            </div>
          </div>
          <div style={{ display: "none" }}>
            {orden ? <Print ref={componentRef} orden={orden} 
            obsequios={Object.keys(orden.pedido.promociones).map((key, i) => orden.pedido.promociones[key])}/> : <></>}
          </div>
        </div>
      ) : (
        <div className="loaderContent">
          <Loader type="ThreeDots" color="#0075bb" height={100} width={100} />
        </div>
      )}
      <Footer />
    </div>
  );
};

/* const Row =()=>{
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    return(
    <Accordion expanded={expanded} onChange={()=>setExpanded(!expanded)}>
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>General settings</Typography>
          <Typography className={classes.secondaryHeading}>I am an accordion</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget
            maximus est, id dignissim quam.
          </Typography>
        </AccordionDetails>
      </Accordion>
    )

} */

export default ThankYou;
